import React from 'react';

import colors from '../sl-colors';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

export default function SolidCheckCircle({ color = colors.success['DEFAULT'], ...props }: Props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0003 18.3333C14.6027 18.3333 18.3337 14.6023 18.3337 10C18.3337 5.39763 14.6027 1.66667 10.0003 1.66667C5.39795 1.66667 1.66699 5.39763 1.66699 10C1.66699 14.6023 5.39795 18.3333 10.0003 18.3333ZM13.7756 7.94195C14.0197 7.69787 14.0197 7.30214 13.7756 7.05806C13.5315 6.81399 13.1358 6.81399 12.8917 7.05806L9.16699 10.7828L7.94227 9.55809C7.69819 9.31401 7.30246 9.31401 7.05838 9.55809C6.81431 9.80217 6.81431 10.1978 7.05838 10.4419L8.72508 12.1086C8.84224 12.2258 9.00124 12.2917 9.16699 12.2917C9.33274 12.2917 9.49174 12.2258 9.60891 12.1086L13.7756 7.94195Z"
        fill={color}
      />
    </svg>
  );
}
